import React from 'react';
import { TiSocialTwitterCircular } from "react-icons/ti";
import { TiSocialPinterestCircular } from "react-icons/ti";
import { TiSocialYoutubeCircular } from "react-icons/ti";


export default function Social() {
    return (

        <ul className="social-icons">
            <li><a href="https://twitter.com/hippiemodernism" target="_blank" rel="noopener noreferrer" title="Connect with Hippie Modernism on Twitter"><TiSocialTwitterCircular size={36} /></a></li>
            <li><a href="https://www.pinterest.com/HippieModernism/_created/" target="_blank" rel="noopener noreferrer" title="Connect with Hippie Modernism on Pinterest"><TiSocialPinterestCircular size={36} /></a></li>
            <li><a href="https://www.youtube.com/c/hippiemodernism/featured" target="_blank" rel="noopener noreferrer" title="Connect with Hippie Modernism on YouTube"><TiSocialYoutubeCircular size={36} /></a></li>
        </ul>
    );
}


// WEBPACK FOOTER //
// ./src/components/Social.js